// Language Configuration
export const LANGUAGES = {
  en: {
    code: 'en',
    name: 'English',
    flag: '🇺🇸'
  },
  zh: {
    code: 'zh',
    name: '中文',
    flag: '🇨🇳',

    // Tutorial translations
    tutorial: {
      header: {
        title: '物业所有者教程',
        step: '第 {current} 步，共 {total} 步'
      },
      navigation: {
        previous: '上一步',
        next: '下一步',
        finish: '完成',
        close: '关闭',
        skip: '跳过教程'
      },
      welcome: {
        title: '欢迎使用 EasyProperty！🎉',
        description: '让我们快速浏览一下您的主页，帮助您开始使用。',
        content: {
          setup: '您已经设置完成！本教程将向您展示如何导航主页并使用关键功能。',
          skip: '您可以随时跳过此教程，稍后从帮助菜单访问。'
        }
      },
      dashboardOverview: {
        title: '主页概览 📊',
        description: '您的主页为您提供物业组合的完整概览。',
        properties: '物业',
        propertiesDesc: '查看总数和状态',
        requests: '请求',
        requestsDesc: '跟踪维护工单',
        expenses: '费用',
        expensesDesc: '监控总成本',
        tenants: '租户',
        tenantsDesc: '管理租户关系'
      },
      navigation: {
        title: '导航和侧边栏 🧭',
        description: '使用侧边栏在主页的不同部分之间导航。',
        sections: {
          title: '主要导航部分：',
          dashboard: '主页 - 概览和统计',
          properties: '物业 - 管理您的房地产组合',
          tenants: '租户 - 处理租户关系',
          tickets: '工单 - 跟踪维护请求'
        },
        tip: {
          label: '提示',
          content: '侧边栏始终可见，提供对所有主要功能的快速访问。'
        }
      },
      properties: {
        title: '管理物业 🏠',
        description: '学习如何有效添加和管理您的物业。',
        adding: {
          title: '添加物业：',
          step1: '点击物业卡片上的"添加物业"按钮',
          step2: '填写物业名称、地址和类型',
          step3: '点击"添加物业"保存'
        },
        management: {
          title: '物业管理：',
          feature1: '查看物业状态（空置/已出租）',
          feature2: '跟踪物业详情和地址',
          feature3: '监控物业表现',
          feature4: '访问详细物业页面'
        },
        proTip: {
          label: '专业提示',
          content: '使用描述性的物业名称，以便在您的组合中轻松识别它们。'
        }
      },
      tenants: {
        title: '租户管理 👥',
        description: '为您的物业创建和管理租户账户。',
        creating: {
          title: '创建租户账户：',
          step1: '点击租户卡片上的"创建租户"',
          step2: '填写租户详情（姓名、邮箱、电话）',
          step3: '选择要分配给他们的物业',
          step4: '设置租金金额和付款计划',
          step5: '点击"创建账户"完成'
        },
        features: {
          title: '租户功能：',
          feature1: '自动账户创建，包含登录凭据',
          feature2: '通过平台直接沟通',
          feature3: '维护请求提交',
          feature4: '付款跟踪和管理'
        },
        note: {
          label: '注意',
          content: '租户将自动收到包含其登录凭据的电子邮件。'
        }
      },
      maintenance: {
        title: '维护请求 🔧',
        description: '跟踪和管理来自租户的维护请求。',
        tracking: {
          title: '请求跟踪：',
          open: '开放 - 新请求',
          inProgress: '进行中 - 正在处理',
          completed: '已完成 - 完成',
          closed: '已关闭 - 已解决'
        },
        managing: {
          title: '管理请求：',
          feature1: '查看请求详情和租户信息',
          feature2: '在需要时分配服务提供商',
          feature3: '跟踪进度和更新',
          feature4: '监控成本和费用'
        },
        tip: {
          label: '提示',
          content: '定期维护有助于保持物业价值和租户满意度。'
        }
      },
      serviceProviders: {
        title: '服务提供商网络 🛠️',
        description: '与经过验证的专业人士联系，进行物业维护和服务。',
        finding: {
          title: '寻找服务提供商：',
          feature1: '浏览您所在地区经过验证的专业人士',
          feature2: '查看评分、评论和专业领域',
          feature3: '比较价格和可用性',
          feature4: '为特定服务请求报价'
        },
        working: {
          title: '与提供商合作：',
          feature1: '通过平台直接沟通',
          feature2: '跟踪工作进度和完成情况',
          feature3: '管理付款和发票',
          feature4: '建立长期关系'
        },
        benefit: {
          label: '优势',
          content: '所有服务提供商都经过预验证，确保质量和可靠性。'
        }
      },
      expenses: {
        title: '财务跟踪 💰',
        description: '监控您的物业费用和财务表现。',
        categories: {
          title: '费用类别：',
          maintenance: '维护和维修',
          management: '物业管理',
          insurance: '保险和税收',
          utilities: '公用事业和服务'
        },
        insights: {
          title: '财务洞察：',
          feature1: '按物业跟踪总费用',
          feature2: '监控维护成本随时间的变化',
          feature3: '分析投资回报率和物业表现',
          feature4: '生成财务报告'
        },
        goal: {
          label: '目标',
          content: '保持详细记录以最大化税收减免并跟踪盈利能力。'
        }
      },
      communication: {
        title: '沟通和聊天 💬',
        description: '通过内置聊天系统与租户和服务提供商保持联系。',
        features: {
          title: '聊天功能：',
          feature1: '与租户直接消息',
          feature2: '服务提供商沟通',
          feature3: '文件和图片共享',
          feature4: '聊天历史和搜索'
        },
        bestPractices: {
          title: '沟通最佳实践：',
          feature1: '及时回应租户询问',
          feature2: '将所有沟通保持在平台内',
          feature3: '使用清晰、专业的语言',
          feature4: '记录重要对话'
        },
        advantage: {
          label: '优势',
          content: '集中式沟通使一切保持有序和可搜索。'
        }
      },
      completion: {
        title: '您已准备就绪！🎯',
        description: '恭喜！您现在知道如何导航和使用您的 EasyProperty 主页。',
        ready: {
          title: '准备开始！',
          description: '您现在拥有有效管理物业组合的所有知识。'
        },
        nextSteps: {
          title: '下一步：',
          step1: '添加您的第一个物业',
          step2: '创建租户账户',
          step3: '探索不同部分',
          step4: '设置您的偏好'
        },
        help: {
          text: '需要帮助？随时从帮助菜单访问此教程或联系我们的支持团队。'
        }
      }
    }
  }
};

// English translations
export const en = {
  // Simple navigation buttons
  previous: 'Previous',
  next: 'Next',
  skip: 'Skip',
  close: 'Close',
  finish: 'Finish',

  // Tutorial translations
  tutorial: {
    header: {
      title: 'Property Owner Tutorial',
      step: 'Step {current} of {total}'
    },
    navigation: {
      previous: 'Previous',
      next: 'Next',
      finish: 'Finish',
      close: 'Close',
      skip: 'Skip Tutorial'
    },
    welcome: {
      title: 'Welcome to EasyProperty! 🎉',
      description: 'Let\'s take a quick tour of your dashboard to help you get started.',
      content: {
        setup: 'You\'re all set up! This tutorial will show you how to navigate your dashboard and use key features.',
        skip: 'You can skip this tutorial anytime and access it later from the help menu.'
      }
    },
    dashboardOverview: {
      title: 'Dashboard Overview 📊',
      description: 'Your dashboard provides a complete overview of your property portfolio.',
      properties: 'Properties',
      propertiesDesc: 'View total count and status',
      requests: 'Requests',
      requestsDesc: 'Track maintenance tickets',
      expenses: 'Expenses',
      expensesDesc: 'Monitor total costs',
      tenants: 'Tenants',
      tenantsDesc: 'Manage tenant relationships'
    },
    navigation: {
      title: 'Navigation & Sidebar 🧭',
      description: 'Use the sidebar to navigate between different sections of your dashboard.',
      sections: {
        title: 'Main Navigation Sections:',
        dashboard: 'Dashboard - Overview and statistics',
        properties: 'Properties - Manage your real estate portfolio',
        tenants: 'Tenants - Handle tenant relationships',
        tickets: 'Tickets - Track maintenance requests'
      },
      tip: {
        label: 'Tip',
        content: 'The sidebar is always visible and provides quick access to all major features.'
      }
    },
    properties: {
      title: 'Managing Properties 🏠',
      description: 'Learn how to effectively add and manage your properties.',
      adding: {
        title: 'Adding Properties:',
        step1: 'Click the "Add Property" button on the properties card',
        step2: 'Fill in property name, address, and type',
        step3: 'Click "Add Property" to save'
      },
      management: {
        title: 'Property Management:',
        feature1: 'View property status (vacant/rented)',
        feature2: 'Track property details and addresses',
        feature3: 'Monitor property performance',
        feature4: 'Access detailed property pages'
      },
      proTip: {
        label: 'Pro Tip',
        content: 'Use descriptive property names to easily identify them in your portfolio.'
      }
    },
    tenants: {
      title: 'Tenant Management 👥',
      description: 'Create and manage tenant accounts for your properties.',
      creating: {
        title: 'Creating Tenant Accounts:',
        step1: 'Click "Create Tenant" on the tenants card',
        step2: 'Fill in tenant details (name, email, phone)',
        step3: 'Select which property to assign them to',
        step4: 'Set rent amount and payment schedule',
        step5: 'Click "Create Account" to complete'
      },
      features: {
        title: 'Tenant Features:',
        feature1: 'Automatic account creation with login credentials',
        feature2: 'Direct communication through the platform',
        feature3: 'Maintenance request submission',
        feature4: 'Payment tracking and management'
      },
      note: {
        label: 'Note',
        content: 'Tenants will automatically receive emails with their login credentials.'
      }
    },
    maintenance: {
      title: 'Maintenance Requests 🔧',
      description: 'Track and manage maintenance requests from tenants.',
      tracking: {
        title: 'Request Tracking:',
        open: 'Open - New requests',
        inProgress: 'In Progress - Being handled',
        completed: 'Completed - Finished',
        closed: 'Closed - Resolved'
      },
      managing: {
        title: 'Managing Requests:',
        feature1: 'View request details and tenant information',
        feature2: 'Assign service providers when needed',
        feature3: 'Track progress and updates',
        feature4: 'Monitor costs and expenses'
      },
      tip: {
        label: 'Tip',
        content: 'Regular maintenance helps maintain property value and tenant satisfaction.'
      }
    },
    serviceProviders: {
      title: 'Service Provider Network 🛠️',
      description: 'Connect with verified professionals for property maintenance and services.',
      finding: {
        title: 'Finding Service Providers:',
        feature1: 'Browse verified professionals in your area',
        feature2: 'View ratings, reviews, and specialties',
        feature3: 'Compare prices and availability',
        feature4: 'Request quotes for specific services'
      },
      working: {
        title: 'Working with Providers:',
        feature1: 'Direct communication through the platform',
        feature2: 'Track work progress and completion',
        feature3: 'Manage payments and invoices',
        feature4: 'Build long-term relationships'
      },
      benefit: {
        label: 'Benefit',
        content: 'All service providers are pre-verified to ensure quality and reliability.'
      }
    },
    expenses: {
      title: 'Financial Tracking 💰',
      description: 'Monitor your property expenses and financial performance.',
      categories: {
        title: 'Expense Categories:',
        maintenance: 'Maintenance & Repairs',
        management: 'Property Management',
        insurance: 'Insurance & Taxes',
        utilities: 'Utilities & Services'
      },
      insights: {
        title: 'Financial Insights:',
        feature1: 'Track total expenses by property',
        feature2: 'Monitor maintenance costs over time',
        feature3: 'Analyze ROI and property performance',
        feature4: 'Generate financial reports'
      },
      goal: {
        label: 'Goal',
        content: 'Keep detailed records to maximize tax deductions and track profitability.'
      }
    },
    communication: {
      title: 'Communication & Chat 💬',
      description: 'Stay connected with tenants and service providers through the built-in chat system.',
      features: {
        title: 'Chat Features:',
        feature1: 'Direct messaging with tenants',
        feature2: 'Service provider communication',
        feature3: 'File and image sharing',
        feature4: 'Chat history and search'
      },
      bestPractices: {
        title: 'Communication Best Practices:',
        feature1: 'Respond promptly to tenant inquiries',
        feature2: 'Keep all communication within the platform',
        feature3: 'Use clear, professional language',
        feature4: 'Document important conversations'
      },
      advantage: {
        label: 'Advantage',
        content: 'Centralized communication keeps everything organized and searchable.'
      }
    },
    completion: {
      title: 'You\'re All Set! 🎯',
      description: 'Congratulations! You now know how to navigate and use your EasyProperty dashboard.',
      ready: {
        title: 'Ready to Start!',
        description: 'You now have all the knowledge to effectively manage your property portfolio.'
      },
      nextSteps: {
        title: 'Next Steps:',
        step1: 'Add your first property',
        step2: 'Create tenant accounts',
        step3: 'Explore different sections',
        step4: 'Set up your preferences'
      },
      help: {
        text: 'Need help? Access this tutorial anytime from the help menu or contact our support team.'
      }
    }
  },

  // Navigation
  nav: {
    home: 'Home',
    features: 'Features',
    serviceProviders: 'Service Providers',
    pricing: 'Pricing',
    signIn: 'Sign In',
    earlyAccess: 'Early Access'
  },

  // Authentication Pages
  auth: {
    login: {
      title: 'Welcome back!',
      subtitle: 'Sign in to your account',
      emailLabel: 'Email Address',
      emailPlaceholder: 'Enter your email',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      signInButton: 'Sign In',
      processing: 'Processing...',
      noAccount: "Don't have an account?",
      createAccount: 'Create New Account',
      copyright: '© 2025 EasyProperty. All rights reserved.'
    }
  },

  // Brand
  brand: {
    name: 'EasyProperty',
    tagline: 'Property Management Made Simple'
  },
  
  // Hero Section
  hero: {
    badge: 'Early Access Program - Limited Spots Available',
    title: 'Property Management',
    subtitle: 'Made Simple',
    programSubtitle: 'Join Our Exclusive Early Access Program',
    description: 'Be among the first to experience our revolutionary property management platform. Connect with verified service providers, manage properties efficiently, and grow your investment portfolio with exclusive early access benefits.',
    earlyAccessBtn: 'Early Access',
    watchDemoBtn: 'Watch Demo',
    trustIndicators: {
      noPayment: 'No payment required',
      prioritySupport: 'Priority support',
      limitedAvailability: 'Limited availability'
    }
  },

  // Statistics Section
  statistics: {
    propertyOwners: 'Property Owners',
    serviceProviders: 'Service Providers',
    propertiesManaged: 'Properties Managed',
    uptime: 'Uptime'
  },
  
  // Scrolling Marquee
  marquee: {
    earlyAccess: '🚀 Early Access Program - Limited Spots Available',
    noPayment: 'No Payment Required During Launch',
    prioritySupport: 'Priority Support Included',
    exclusiveFeatures: 'Exclusive Platform Features',
    firstBatch: 'Join Our First Batch of Users',
    onboarding: 'Professional Onboarding Support',
    verifiedNetwork: 'Verified Service Provider Network',
    advancedTools: 'Advanced Property Management Tools',
    analytics: 'Real-time Analytics & Reporting',
    mobileApp: 'Mobile App Access',
    customerSuccess: '24/7 Customer Success Team'
  },
  
  // Early Access Banner
  earlyAccessBanner: {
    title: '🚀 Early Access Program',
    description: 'Limited spots available • No payment required • Priority support included',
    joinNow: 'Join Now'
  },
  
  // Features Section
  features: {
    title: 'Powerful Features for Modern Property Management',
    subtitle: 'Experience these features first with our exclusive early access program.',
    features: [
      {
        title: 'Property Portfolio Management',
        description: 'Manage multiple properties from a single dashboard with comprehensive tracking and analytics.'
      },
      {
        title: 'Service Provider Network',
        description: 'Connect with verified professionals for maintenance, repairs, and property services.'
      },
      {
        title: 'Tenant Management',
        description: 'Streamline tenant onboarding, communication, and payment collection processes.'
      },
      {
        title: 'Financial Tracking',
        description: 'Monitor income, expenses, and ROI with detailed financial reporting and insights.'
      },
      {
        title: 'Document Management',
        description: 'Store and organize all property-related documents securely in one place.'
      },
      {
        title: 'Mobile Accessibility',
        description: 'Access your property management tools anywhere, anytime with our mobile app.'
      }
    ]
  },
  
  // Service Providers Section
  serviceProviders: {
    title: 'Explore Service Providers',
    subtitle: 'Early access users get priority connection to our verified service provider network.',
    joinPlatform: 'Early Access',
    learnMore: 'Learn More',
    searchPlaceholder: 'Search by name, description, or location...',
    allSpecialties: 'All Specialties',
    sortByRating: 'Sort by Rating',
    sortByName: 'Sort by Name',
    sortByLocation: 'Sort by Location',
    loading: 'Loading service providers...',
    noResults: 'No service providers found',
    noResultsDescription: 'Try adjusting your search criteria or check back later.',
    servicesOffered: 'Services Offered:',
    specialties: {
      plumbing: 'Plumbing',
      electrical: 'Electrical',
      hvac: 'HVAC',
      carpentry: 'Carpentry',
      painting: 'Painting',
      cleaning: 'Cleaning',
      landscaping: 'Landscaping',
      roofing: 'Roofing'
    }
  },
  
  // CTA Section
  cta: {
    title: 'Ready to Join Our Exclusive Early Access Program?',
    description: 'Limited spots available for early access. Join now and be among the first to experience the future of property management.',
    button: 'Join Early Access'
  },
  
  // Footer
  footer: {
    description: 'Simplifying property management for owners and service providers.',
    copyright: 'All rights reserved.',
    platform: 'Platform',
    support: 'Support',
    connect: 'Connect',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    serviceProviders: 'Service Providers',
    features: 'Features',
    pricing: 'Pricing',
    helpCenter: 'Help Center',
    contactUs: 'Contact Us',
    privacyPolicy: 'Privacy Policy',
    aboutUs: 'About Us',
    blog: 'Blog',
    careers: 'Careers'
  },
  
  // Registration Page
  registration: {
    title: 'Choose Your Account Type',
    subtitle: 'Select the account type that best fits your needs. Property owners can join our exclusive early access program, while service providers join our premium network.',
    propertyOwner: {
      badge: 'EARLY ACCESS',
      title: 'Property Owner',
      description: 'Perfect for landlords, property managers, and real estate investors who want to streamline their property management.',
      benefits: [
        'Join our exclusive early access program',
        'Free access to all platform features',
        'Connect with verified service providers',
        'Priority support and onboarding',
        'Limited spots available'
      ],
      button: 'Join Waiting List'
    },
    serviceProvider: {
      badge: 'FREE + PREMIUM',
      title: 'Service Provider',
      description: 'Join our network of verified professionals and get access to property owners looking for your services.',
      benefits: [
        'Free registration & account creation',
        'Admin approval required',
        'Upgrade to premium: $99 one-time fee',
        'Verified professional badge',
        'Priority access to leads & job tickets'
      ],
      button: 'Join as Provider - Free'
    },
    additionalInfo: {
      signIn: 'Already have an account?',
      signInLink: 'Sign in here',
      help: 'Need help choosing?',
      contact: 'Contact our support team',
      earlyAccessNotice: {
        title: 'Early Access Program',
        description: 'We\'re currently accepting a limited number of property owners for our early access program. Join the waiting list to be notified when your account is ready. No payment required during early access.'
      }
    },
    serviceProviderRegistration: {
      title: 'Join as Service Provider',
      subtitle: 'Create your professional account and start connecting with property owners.',
      steps: {
        step1: '1',
        step2: '2',
        accountInfo: 'Account Information',
        businessInfo: 'Business Information'
      },
      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        emailAddress: 'Email Address',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        phoneNumber: 'Phone Number',
        businessName: 'Business Name',
        specialty: 'Specialty',
        serviceArea: 'Service Area',
        businessDescription: 'Business Description',
        referralCode: 'Referral Code',
        invited: 'Invited',
        optional: 'Optional'
      },
      placeholders: {
        selectSpecialty: 'Select your specialty',
        serviceAreaPlaceholder: 'e.g., New York, NY',
        businessDescriptionPlaceholder: 'Tell property owners about your services, experience, and what makes you unique...',
        referralCodePlaceholder: 'Enter referral code if you have one',
        invitedPlaceholder: 'You were invited by a property owner'
      },
      specialties: {
        plumbing: 'Plumbing',
        electrical: 'Electrical',
        hvac: 'HVAC',
        carpentry: 'Carpentry',
        painting: 'Painting',
        cleaning: 'Cleaning',
        landscaping: 'Landscaping',
        roofing: 'Roofing',
        general: 'General'
      },
      buttons: {
        continueToBusiness: 'Continue to Business Details',
        back: 'Back',
        completeRegistration: 'Complete Registration',
        creatingAccount: 'Creating Account...'
      },
      terms: {
        agreeTo: 'I agree to the',
        termsOfService: 'Terms of Service',
        and: 'and',
        privacyPolicy: 'Privacy Policy'
      },
      referral: {
        invitedBy: 'You were invited by',
        invitedByReferrer: 'Invited by {name}'
      },
      info: {
        freeRegistration: 'Free Registration Process',
        benefits: [
          'No registration fee required',
          'Admin approval within 24-48 hours',
          'Basic access after approval',
          'Upgrade to premium ($99) for verified badge',
          'Priority access to leads and job tickets',
          'No monthly fees'
        ]
      },
      navigation: {
        home: 'Home',
        signIn: 'Sign In'
      },
      footer: {
        alreadyHaveAccount: 'Already have an account?',
        signInHere: 'Sign in here'
      }
    }
  },
  
  // Demo Modal
  demoModal: {
    title: 'Try the platform',
    subtitle: 'See your dashboard in action — no signup required',
    description: 'Explore the property owner dashboard with sample data: properties, tenants, maintenance requests, and expenses. See exactly what you\'ll get.',
    launchDemo: 'Launch interactive demo',
    orGetNotified: 'Or get notified about new features',
    emailPlaceholder: 'Enter your email',
    getNotified: 'Get Notified',
    notifySuccess: "We'll notify you when we add new features.",
    close: 'Close',
    features: [
      'Interactive Dashboard Tour',
      'Feature Demonstrations',
      'Real Use Case Examples',
      'Q&A Session'
    ],
    launchInfo: 'Estimated Launch: December 2025',
    emailLabel: 'Get notified when demo is ready:',
    captchaLabel: 'Security check: What is 3 + 5?',
    captchaPlaceholder: 'Enter answer'
  },
  
  // Features Page
  featuresPage: {
    hero: {
      title: 'Powerful Features for Modern Property Management',
      subtitle: 'Experience these features first with our exclusive early access program.',
      button: 'Early Access'
    },
    features: {
      propertyManagement: {
        category: 'Property Management',
        dashboard: {
          title: 'Property Dashboard',
          description: 'Centralized view of all your properties with real-time analytics and insights'
        },
        documents: {
          title: 'Document Management',
          description: 'Store and organize property documents, contracts, and maintenance records'
        },
        financial: {
          title: 'Financial Tracking',
          description: 'Monitor income, expenses, and ROI for each property investment'
        },
        maintenance: {
          title: 'Maintenance Scheduling',
          description: 'Automated maintenance reminders and service scheduling'
        }
      },
      tenantManagement: {
        category: 'Tenant Management',
        portal: {
          title: 'Tenant Portal',
          description: 'Self-service portal for rent payments, maintenance requests, and communication'
        },
        rent: {
          title: 'Rent Collection',
          description: 'Automated rent collection with multiple payment methods and late fee tracking'
        },
        communication: {
          title: 'Communication Hub',
          description: 'Built-in messaging system for seamless landlord-tenant communication'
        },
        lease: {
          title: 'Lease Management',
          description: 'Digital lease agreements, renewals, and compliance tracking'
        }
      },
      serviceProvider: {
        category: 'Service Provider Network',
        verified: {
          title: 'Verified Professionals',
          description: 'Pre-screened and rated service providers for all property needs'
        },
        booking: {
          title: 'Instant Booking',
          description: 'Book maintenance services with real-time availability and pricing'
        },
        tracking: {
          title: 'Service Tracking',
          description: 'Monitor service progress and completion with photo documentation'
        },
        cost: {
          title: 'Cost Management',
          description: 'Compare quotes, track expenses, and manage service budgets'
        }
      },
      analytics: {
        category: 'Analytics & Reporting',
        performance: {
          title: 'Performance Metrics',
          description: 'Comprehensive analytics on property performance and tenant satisfaction'
        },
        market: {
          title: 'Market Insights',
          description: 'Local market trends and property value analysis'
        },
        roi: {
          title: 'ROI Calculator',
          description: 'Advanced tools to calculate and optimize your investment returns'
        },
        reports: {
          title: 'Custom Reports',
          description: 'Generate detailed reports for investors, accountants, and tax purposes'
        }
      }
    },
    integrations: {
      title: 'Seamless Integrations',
      subtitle: 'Connect with your favorite tools and services to streamline your workflow.',
      quickBooks: { name: 'QuickBooks' },
      stripe: { name: 'Stripe' },
      googleCalendar: { name: 'Google Calendar' },
      slack: { name: 'Slack' },
      zapier: { name: 'Zapier' },
      mailchimp: { name: 'Mailchimp' },
      dropbox: { name: 'Dropbox' },
      trello: { name: 'Trello' }
    },
    cta: {
      title: 'Ready to Experience the Future of Property Management?',
      subtitle: 'Join thousands of property owners who trust EasyProperty to manage their investments efficiently.',
      earlyAccess: 'Early Access',
      viewPricing: 'View Pricing'
    }
  },

  // Pricing Page
  pricingPage: {
    hero: {
      title: 'Simple, Transparent Pricing',
      subtitle: 'Join our exclusive early access program. Experience the full platform at no cost during our launch phase.',
      button: 'Early Access',
      viewFeatures: 'View Features'
    },
    pricing: {
      title: 'Choose Your Plan',
      description: 'Early access program details. No payment required during our launch phase.',
      monthly: 'Monthly',
      yearly: 'Yearly',
      save20: 'Save 20%',
      saveAmount: 'Save ${amount} per year!',
      perMonth: '/month',
      perYear: '/year',
      startFreeTrial: 'Start Free Trial',
      getStarted: 'Get Started',
      mostPopular: 'Most Popular'
    },
    plans: {
      starter: {
        name: 'Starter',
        description: 'Perfect for individual property owners',
        features: [
          'Up to 5 properties',
          'Basic tenant management',
          'Maintenance request tracking',
          'Email support',
          'Mobile app access',
          'Basic reporting'
        ]
      },
      professional: {
        name: 'Professional',
        description: 'Ideal for growing property portfolios',
        features: [
          'Up to 25 properties',
          'Advanced tenant portal',
          'Automated rent collection',
          'Service provider network',
          'Priority support',
          'Advanced analytics',
          'Document management',
          'Multi-user access'
        ]
      },
      enterprise: {
        name: 'Enterprise',
        description: 'For large property management companies',
        features: [
          'Unlimited properties',
          'Custom integrations',
          'White-label solutions',
          'Dedicated account manager',
          '24/7 phone support',
          'Custom reporting',
          'API access',
          'Advanced security features'
        ]
      }
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about our pricing and plans.',
      questions: {
        changePlan: {
          question: 'Can I change my plan at any time?',
          answer: 'Yes! You can upgrade or downgrade your plan at any time. Changes take effect immediately, and we\'ll prorate any billing adjustments.'
        },
        freeTrial: {
          question: 'What\'s included in the free trial?',
          answer: 'The free trial gives you full access to all features of the Starter plan for 30 days. No credit card required, and you can cancel anytime.'
        },
        volumeDiscounts: {
          question: 'Do you offer discounts for multiple properties?',
          answer: 'Yes! We offer volume discounts for property management companies with large portfolios. Contact our sales team for custom pricing.'
        },
        setupFee: {
          question: 'Is there a setup fee?',
          answer: 'No setup fees! All plans include free onboarding and migration assistance to help you get started quickly.'
        },
        paymentMethods: {
          question: 'What payment methods do you accept?',
          answer: 'We accept all major credit cards, PayPal, and bank transfers for annual plans. All payments are processed securely.'
        }
      }
    },
    comparison: {
      title: 'Plan Comparison',
      subtitle: 'See exactly what\'s included in each plan at a glance.',
      features: 'Features',
      properties: 'Properties',
      tenantManagement: 'Tenant Management',
      maintenanceTracking: 'Maintenance Tracking',
      serviceProviderNetwork: 'Service Provider Network',
      rentCollection: 'Rent Collection',
      documentManagement: 'Document Management',
      analyticsReporting: 'Analytics & Reporting',
      apiAccess: 'API Access',
      prioritySupport: 'Priority Support',
      whiteLabelSolutions: 'White-label Solutions'
    },
    cta: {
      title: 'Ready to Get Started?',
      subtitle: 'Join thousands of property owners who trust EasyProperty to manage their investments efficiently.',
      earlyAccess: 'Early Access',
      viewFeatures: 'View Features'
    }
  },

  // Service Providers Page
  serviceProvidersPage: {
    hero: {
      title: 'Trusted Service Providers',
      subtitle: 'at Your Fingertips',
      description: 'Connect with verified professionals for all your property maintenance and management needs. Quality service, competitive pricing, and peace of mind.',
      joinAsOwner: 'Join as Property Owner',
      becomeProvider: 'Become a Service Provider'
    },
    stats: {
      // Stats section translations
    },
    search: {
      placeholder: 'Search providers, services, or locations...',
      allSpecialties: 'All Specialties',
      sortByRating: 'Sort by Rating',
      sortByName: 'Sort by Name',
      sortByLocation: 'Sort by Location'
    },
    specialty: {
      all: 'All Specialties'
    },
    sort: {
      rating: 'Rating',
      name: 'Name',
      location: 'Location'
    },
    loading: 'Loading service providers...',
    noResults: 'No service providers found',
    noResultsDescription: 'Try adjusting your search criteria or browse all specialties.',
    noProvidersFound: {
      title: 'No service providers found',
      description: 'Try adjusting your search criteria or check back later.',
      joinAsProvider: 'Join as Service Provider'
    },
    provider: {
      servicesOffered: 'Services Offered:',
      contactProvider: 'Contact Provider',
      viewProfile: 'View Profile'
    },
    cta: {
      title: 'Ready to Connect with Top Service Providers?',
      description: 'Join thousands of property owners who trust EasyProperty to connect with verified professionals.',
      getStarted: 'Get Started Free',
      learnMore: 'Learn More'
    },
    servicesOffered: 'Services Offered',
    specialties: {
      plumbing: 'Plumbing',
      electrical: 'Electrical',
      hvac: 'HVAC',
      carpentry: 'Carpentry',
      painting: 'Painting',
      cleaning: 'Cleaning',
      landscaping: 'Landscaping',
      roofing: 'Roofing',
      general: 'General'
    }
  },

  // Sidebar Navigation
  sidebar: {
    dashboard: 'Dashboard',
    properties: 'Properties',
    tenants: 'Tenants',
    tickets: 'Tickets',
    expenses: 'Expenses',
    earnings: 'Earnings',
    serviceProviders: 'Service Providers',
    chats: 'Chats',
    helpTutorial: 'Help & Tutorial',
    logout: 'Log Out',
    showTutorial: 'Show Tutorial',
    notifications: 'Notifications',
    markAllRead: 'Mark all as read',
    noNotifications: 'No notifications'
  },

  // Feedback System
  feedback: {
    title: 'Submit Feedback',
    helpMessage: 'Your feedback helps us improve EasyProperty for all users. We appreciate your input!',
    feedbackType: 'Feedback Type',
    priority: 'Priority',
    content: 'Feedback Content',
    contentPlaceholder: 'Please describe your feedback in detail. Include specific examples if possible...',
    deviceType: 'Device Type',
    browserInfo: 'Browser Info',
    submit: 'Submit Feedback',
    submitting: 'Submitting...',
    pleaseEnterContent: 'Please enter your feedback content.',
    thankYouMessage: 'Thank you for your feedback! We appreciate your input to improve EasyProperty.',
    submissionError: 'Failed to submit feedback. Please try again.',
    unknownUser: 'Unknown User',
    types: {
      general: 'General Comment',
      bug: 'Bug Report',
      feature: 'Feature Request',
      uiux: 'UI/UX Feedback',
      performance: 'Performance Issue'
    },
    priorities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical'
    },
    devices: {
      desktop: 'Desktop',
      mobile: 'Mobile',
      tablet: 'Tablet'
    }
  },

  // Common UI Elements
  common: {
    cancel: 'Cancel'
  },

  // Dashboard Translations
  dashboard: {
    // Common Dashboard Elements
    common: {
      loading: 'Loading...',
      refresh: 'Refresh',
      viewAll: 'View All',
      addNew: 'Add New',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      close: 'Close',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      actions: 'Actions',
      status: 'Status',
      createdAt: 'Created',
      updatedAt: 'Updated',
      noData: 'No data available',
      emptyState: 'Get started by adding your first item',
      help: 'Help',
      tutorial: 'Tutorial',
      skip: 'Skip',
      next: 'Next',
      previous: 'Previous',
      finish: 'Finish',
      complete: 'Complete'
    },

    // Property Owner Dashboard
    owner: {
      title: 'Property Owner Dashboard',
      welcome: 'Welcome back',
      stats: {
        properties: 'Total Properties',
        tenants: 'Total Tenants',
        tickets: 'Active Requests',
        expenses: 'Total Expenses',
        revenue: 'Total Revenue',
        occupancy: 'Occupancy Rate'
      },
      sections: {
        properties: {
          title: 'Your Properties',
          subtitle: 'Manage your property portfolio',
          addProperty: 'Add Property',
          noProperties: 'No properties yet',
          emptyState: 'Start building your portfolio by adding your first property.',
          addFirstProperty: 'Add Your First Property',
          needHelp: 'Need help?',
          propertyName: 'Property Name',
          address: 'Address',
          type: 'Property Type',
          status: 'Status',
          vacant: 'Vacant',
          occupied: 'Occupied'
        },
        tenants: {
          title: 'Your Tenants',
          subtitle: 'Manage tenant relationships',
          createTenant: 'Create Tenant',
          noTenants: 'No tenants yet',
          emptyState: 'Assign tenants to your properties to start managing them.',
          createFirstTenant: 'Create First Tenant',
          needHelp: 'Need help?',
          tenantName: 'Tenant Name',
          email: 'Email',
          phone: 'Phone',
          rent: 'Rent Amount',
          leaseStart: 'Lease Start',
          leaseEnd: 'Lease End'
        },
        maintenance: {
          title: 'Recent Requests',
          subtitle: 'Track maintenance and repair requests',
          noRequests: 'No maintenance requests',
          emptyState: 'Requests will appear here when tenants submit maintenance tickets.',
          learnHow: 'Learn how it works',
          requestTitle: 'Request Title',
          property: 'Property',
          priority: 'Priority',
          assignedTo: 'Assigned To',
          estimatedCost: 'Estimated Cost'
        },
        financial: {
          title: 'Financial Overview',
          subtitle: 'Track your property investments',
          income: 'Income',
          expenses: 'Expenses',
          profit: 'Profit',
          roi: 'ROI',
          monthly: 'Monthly',
          yearly: 'Yearly'
        }
      },
      modals: {
        addProperty: {
          title: 'Add New Property',
          description: 'Add a new property to your portfolio'
        },
        createTenant: {
          title: 'Create New Tenant',
          description: 'Create a tenant account and assign to a property'
        },
        createTenantAccount: {
          title: 'Create Tenant Account',
          description: 'Create a new tenant account and assign them to a property',
          form: {
            tenantName: 'Tenant Name',
            tenantNamePlaceholder: 'Enter tenant\'s full name',
            emailAddress: 'Email Address',
            emailPlaceholder: 'Enter email address',
            phoneNumber: 'Phone Number',
            phonePlaceholder: 'Enter phone number',
            property: 'Property',
            propertyPlaceholder: 'Select a property',
            leaseStartDate: 'Lease Start Date',
            leaseEndDate: 'Lease End Date',
            monthlyRent: 'Monthly Rent',
            rentPlaceholder: 'Enter monthly rent',
            defaultPassword: 'Default Password',
            passwordPlaceholder: 'Enter default password',
            confirmPassword: 'Confirm Password',
            confirmPlaceholder: 'Confirm default password',
            passwordHint: 'Minimum 6 characters'
          },
          info: {
            title: 'Important Information',
            description: 'After creating the account, you\'ll receive the login credentials to share with the tenant. The tenant will be prompted to change their password on their first login.'
          },
          buttons: {
            cancel: 'Cancel',
            createAccount: 'Create Tenant Account',
            creating: 'Creating Account...'
          },
          success: {
            title: 'Tenant Account Created Successfully!',
            credentials: 'Login Credentials',
            shareInstructions: 'Please share these credentials with the tenant. They will be prompted to change their password on first login.',
            copyCredentials: 'Copy Credentials',
            credentialsCopied: 'Credentials copied to clipboard!',
            close: 'Close'
          },
          errors: {
            tenantNameRequired: 'Tenant name is required',
            emailRequired: 'Email is required',
            phoneRequired: 'Phone number is required',
            propertyRequired: 'Property selection is required',
            leaseStartRequired: 'Lease start date is required',
            leaseEndRequired: 'Lease end date is required',
            rentRequired: 'Monthly rent is required',
            passwordRequired: 'Default password is required',
            passwordsMismatch: 'Passwords do not match',
            passwordTooShort: 'Password must be at least 6 characters long',
            noVacantProperties: 'No vacant properties available',
            selectedPropertyNotFound: 'Selected property not found'
          }
        },
        passwordChange: {
          title: 'Change Password Required',
          description: 'For security reasons, you must change your default password before continuing.',
          currentPassword: 'Current Password',
          newPassword: 'New Password',
          confirmPassword: 'Confirm New Password',
          passwordHint: 'Password must be at least 6 characters long'
        },
        profileCompletion: {
          title: 'Complete Your Profile',
          description: 'Please complete your profile by providing your contact information. This helps us provide better service.',
          phoneNumber: 'Phone Number',
          address: 'Address',
          phoneRequired: 'Required for property owner accounts',
          addressRequired: 'Required for property owner accounts'
        }
      },
      pages: {
        properties: {
          title: 'Properties Management',
          subtitle: 'Manage your property portfolio',
          addProperty: 'Add Property',
          editProperty: 'Edit Property',
          totalProperties: 'Total Properties',
          inPortfolio: 'In your portfolio',
          yourProperties: 'Your Properties',
          managePortfolio: 'Manage your real estate portfolio',
          propertyName: 'Property Name',
          address: 'Address',
          type: 'Property Type',
          status: 'Status',
          monthlyRent: 'Monthly Rent',
          bedrooms: 'Bedrooms',
          bathrooms: 'Bathrooms',
          squareFootage: 'Square Footage',
          residential: 'Residential',
          commercial: 'Commercial',
          industrial: 'Industrial',
          vacant: 'Vacant',
          occupied: 'Occupied',
          maintenance: 'Maintenance',
          actions: 'Actions',
          edit: 'Edit',
          delete: 'Delete',
          assignTenant: 'Assign Tenant',
          viewDetails: 'View Details',
          confirmDelete: 'Are you sure you want to delete this property?',
          deleteSuccess: 'Property deleted successfully',
          addSuccess: 'Property added successfully',
          updateSuccess: 'Property updated successfully',
          property: 'property',
          properties: 'properties'
        },
        tenants: {
          title: 'Tenants Management',
          subtitle: 'Manage your tenant relationships',
          createTenant: 'Create Tenant',
          totalTenants: 'Total Tenants',
          managedByYou: 'Managed by you',
          yourTenants: 'Your Tenants',
          manageRelationships: 'Manage tenant relationships',
          tenantName: 'Tenant Name',
          email: 'Email',
          phone: 'Phone',
          property: 'Property',
          leaseStart: 'Lease Start',
          leaseEnd: 'Lease End',
          rentAmount: 'Rent Amount',
          status: 'Status',
          active: 'Active',
          inactive: 'Inactive',
          pending: 'Pending',
          actions: 'Actions',
          edit: 'Edit',
          delete: 'Delete',
          sendMessage: 'Send Message',
          viewLease: 'View Lease',
          confirmDelete: 'Are you sure you want to remove this tenant?',
          deleteSuccess: 'Tenant removed successfully',
          createSuccess: 'Tenant created successfully',
          tenant: 'tenant',
          tenants: 'tenants'
        },
        tickets: {
          title: 'Maintenance Tickets',
          subtitle: 'Track and manage maintenance requests',
          newTicket: 'New Ticket',
          totalTickets: 'Total Tickets',
          activeRequests: 'Active requests',
          yourTickets: 'Your Tickets',
          trackRequests: 'Track maintenance and repair requests',
          ticketId: 'Ticket ID',
          columnTitle: 'Title',
          property: 'Property',
          tenant: 'Tenant',
          priority: 'Priority',
          status: 'Status',
          assignedTo: 'Assigned To',
          createdAt: 'Created',
          updatedAt: 'Updated',
          open: 'Open',
          inProgress: 'In Progress',
          completed: 'Completed',
          closed: 'Closed',
          high: 'High',
          medium: 'Medium',
          low: 'Low',
          urgent: 'Urgent',
          actions: 'Actions',
          view: 'View',
          assign: 'Assign',
          close: 'Close',
          reopen: 'Reopen',
          ticket: 'ticket',
          tickets: 'tickets'
        },
        expenses: {
          title: 'Expenses Management',
          subtitle: 'Track and manage property expenses',
          addExpense: 'Add Expense',
          totalExpenses: 'Total Expenses',
          thisMonth: 'This month',
          yourExpenses: 'Your Expenses',
          trackExpenses: 'Track and manage property expenses',
          description: 'Description',
          amount: 'Amount',
          category: 'Category',
          property: 'Property',
          date: 'Date',
          receipt: 'Receipt',
          actions: 'Actions',
          edit: 'Edit',
          delete: 'Delete',
          viewReceipt: 'View Receipt',
          confirmDelete: 'Are you sure you want to delete this expense?',
          deleteSuccess: 'Expense deleted successfully',
          addSuccess: 'Expense added successfully',
          updateSuccess: 'Expense updated successfully'
        },
        chats: {
          title: 'Messages & Communication',
          subtitle: 'Communicate with tenants and service providers',
          newMessage: 'New Message',
          totalChats: 'Total Conversations',
          activeChats: 'Active chats',
          yourChats: 'Your Conversations',
          communicateWith: 'Communicate with tenants and service providers',
          searchChats: 'Search conversations...',
          noChats: 'No conversations yet',
          startChatting: 'Start your first conversation',
          sendMessage: 'Send message...',
          online: 'Online',
          offline: 'Offline',
          typing: 'typing...',
          lastSeen: 'Last seen'
        }
      },
      onboarding: {
        welcome: 'Welcome to EasyProperty! 🎉',
        subtitle: 'You\'re all set up and ready to start managing your properties. Let\'s take a quick tour to help you get started.',
        startTutorial: 'Start Tutorial',
        skipForNow: 'Skip for now',
        tutorial: {
          title: 'Property Owner Tutorial',
          welcome: 'Welcome to EasyProperty! 🎉',
          dashboardOverview: 'Dashboard Overview 📊',
          navigation: 'Navigation & Sidebar 🧭',
          properties: 'Managing Properties 🏠',
          tenants: 'Tenant Management 👥',
          maintenance: 'Maintenance Requests 🔧',
          serviceProviders: 'Service Provider Network 🛠️',
          expenses: 'Financial Tracking 💰',
          communication: 'Communication & Chat 💬',
          completion: 'You\'re All Set! 🎯'
        }
      },


    },

    // Service Provider Dashboard
    serviceProvider: {
      title: 'Service Provider Dashboard',
      welcome: 'Welcome back',
      stats: {
        jobs: 'Total Jobs',
        completed: 'Completed',
        pending: 'Pending',
        earnings: 'Total Earnings',
        rating: 'Average Rating',
        reviews: 'Total Reviews'
      },
      sections: {
        jobs: {
          title: 'Active Jobs',
          subtitle: 'Manage your current service requests',
          noJobs: 'No active jobs',
          emptyState: 'Jobs will appear here when property owners assign work to you.',
          jobTitle: 'Job Title',
          property: 'Property',
          owner: 'Property Owner',
          priority: 'Priority',
          estimatedTime: 'Estimated Time',
          status: 'Status'
        },
        requests: {
          title: 'Service Requests',
          subtitle: 'New requests from property owners',
          noRequests: 'No new service requests',
          emptyState: 'New requests will appear here as property owners submit them.',
          viewDetails: 'View Details',
          accept: 'Accept',
          decline: 'Decline',
          quote: 'Send Quote'
        },
        schedule: {
          title: 'Schedule',
          subtitle: 'Manage your availability and appointments',
          today: 'Today',
          thisWeek: 'This Week',
          thisMonth: 'This Month',
          available: 'Available',
          busy: 'Busy',
          unavailable: 'Unavailable'
        },
        earnings: {
          title: 'Earnings & Analytics',
          subtitle: 'Track your income and performance',
          totalEarnings: 'Total Earnings',
          thisMonth: 'This Month',
          thisYear: 'This Year',
          averagePerJob: 'Average per Job',
          topServices: 'Top Services'
        }
      },
      modals: {
        jobDetails: {
          title: 'Job Details',
          description: 'View and manage job information'
        },
        sendQuote: {
          title: 'Send Quote',
          description: 'Provide a quote for the requested service'
        },
        updateStatus: {
          title: 'Update Job Status',
          description: 'Update the progress of your current job'
        }
      }
    },

    // Tenant Dashboard
    tenant: {
      title: 'Tenant Dashboard',
      welcome: 'Welcome back',
      stats: {
        rent: 'Monthly Rent',
        dueDate: 'Due Date',
        balance: 'Balance',
        maintenance: 'Open Requests',
        documents: 'Documents',
        messages: 'Messages'
      },
      sections: {
        rent: {
          title: 'Rent & Payments',
          subtitle: 'Manage your rent payments and view history',
          currentRent: 'Current Rent',
          nextPayment: 'Next Payment',
          paymentHistory: 'Payment History',
          makePayment: 'Make Payment',
          paymentMethods: 'Payment Methods',
          noPayments: 'No payment history available'
        },
        maintenance: {
          title: 'Maintenance Requests',
          subtitle: 'Submit and track maintenance requests',
          newRequest: 'New Request',
          noRequests: 'No maintenance requests',
          emptyState: 'Submit a request when you need maintenance or repairs.',
          submitRequest: 'Submit Request',
          requestTitle: 'Request Title',
          description: 'Description',
          priority: 'Priority',
          category: 'Category',
          status: 'Status'
        },
        documents: {
          title: 'Documents',
          subtitle: 'Access your lease and important documents',
          lease: 'Lease Agreement',
          rules: 'House Rules',
          policies: 'Policies',
          noDocuments: 'No documents available',
          download: 'Download',
          view: 'View'
        },
        communication: {
          title: 'Communication',
          subtitle: 'Message your property owner and service providers',
          newMessage: 'New Message',
          noMessages: 'No messages',
          emptyState: 'Start a conversation with your property owner.',
          sendMessage: 'Send Message',
          to: 'To',
          subject: 'Subject',
          message: 'Message'
        }
      },
      modals: {
        newRequest: {
          title: 'New Maintenance Request',
          description: 'Submit a new maintenance or repair request'
        },
        newMessage: {
          title: 'New Message',
          description: 'Send a message to your property owner'
        },
        payment: {
          title: 'Make Payment',
          description: 'Pay your rent or other charges'
        }
      }
    }
  }
};

// Chinese translations
export const zh = {
  // Simple navigation buttons
  previous: '上一步',
  next: '下一步',
  skip: '跳过',
  close: '关闭',
  finish: '完成',

  // Tutorial translations
  tutorial: {
    header: {
      title: '物业所有者教程',
      step: '第 {current} 步，共 {total} 步'
    },
    navigation: {
      previous: '上一步',
      next: '下一步',
      finish: '完成',
      close: '关闭',
      skip: '跳过教程'
    },
    welcome: {
      title: '欢迎使用 EasyProperty！🎉',
              description: '让我们快速浏览一下您的主页，帮助您开始使用。',
      content: {
                  setup: '您已经设置完成！本教程将向您展示如何导航主页并使用关键功能。',
        skip: '您可以随时跳过此教程，稍后从帮助菜单访问。'
      }
    },
    dashboardOverview: {
              title: '主页概览 📊',
              description: '您的主页为您提供物业组合的完整概览。',
      properties: '物业',
      propertiesDesc: '查看总数和状态',
      requests: '请求',
      requestsDesc: '跟踪维护工单',
      expenses: '费用',
      expensesDesc: '监控总成本',
      tenants: '租户',
      tenantsDesc: '管理租户关系'
    },
    navigation: {
      title: '导航和侧边栏 🧭',
              description: '使用侧边栏在主页的不同部分之间导航。',
      sections: {
        title: '主要导航部分：',
                  dashboard: '主页 - 概览和统计',
        properties: '物业 - 管理您的房地产组合',
        tenants: '租户 - 处理租户关系',
        tickets: '工单 - 跟踪维护请求'
      },
      tip: {
        label: '提示',
        content: '侧边栏始终可见，提供对所有主要功能的快速访问。'
      }
    },
    properties: {
      title: '管理物业 🏠',
      description: '学习如何有效添加和管理您的物业。',
      adding: {
        title: '添加物业：',
        step1: '点击物业卡片上的"添加物业"按钮',
        step2: '填写物业名称、地址和类型',
        step3: '点击"添加物业"保存'
      },
      management: {
        title: '物业管理：',
        feature1: '查看物业状态（空置/已出租）',
        feature2: '跟踪物业详情和地址',
        feature3: '监控物业表现',
        feature4: '访问详细物业页面'
      },
      proTip: {
        label: '专业提示',
        content: '使用描述性的物业名称，以便在您的组合中轻松识别它们。'
      }
    },
    tenants: {
      title: '租户管理 👥',
      description: '为您的物业创建和管理租户账户。',
      creating: {
        title: '创建租户账户：',
        step1: '点击租户卡片上的"创建租户"',
        step2: '填写租户详情（姓名、邮箱、电话）',
        step3: '选择要分配给他们的物业',
        step4: '设置租金金额和付款计划',
        step5: '点击"创建账户"完成'
      },
      features: {
        title: '租户功能：',
        feature1: '自动账户创建，包含登录凭据',
        feature2: '通过平台直接沟通',
        feature3: '维护请求提交',
        feature4: '付款跟踪和管理'
      },
      note: {
        label: '注意',
        content: '租户将自动收到包含其登录凭据的电子邮件。'
      }
    },
    maintenance: {
      title: '维护请求 🔧',
      description: '跟踪和管理来自租户的维护请求。',
      tracking: {
        title: '请求跟踪：',
        open: '开放 - 新请求',
        inProgress: '进行中 - 正在处理',
        completed: '已完成 - 完成',
        closed: '已关闭 - 已解决'
      },
      managing: {
        title: '管理请求：',
        feature1: '查看请求详情和租户信息',
        feature2: '在需要时分配服务提供商',
        feature3: '跟踪进度和更新',
        feature4: '监控成本和费用'
      },
      tip: {
        label: '提示',
        content: '定期维护有助于保持物业价值和租户满意度。'
      }
    },
    serviceProviders: {
      title: '服务提供商网络 🛠️',
      description: '与经过验证的专业人士联系，进行物业维护和服务。',
      finding: {
        title: '寻找服务提供商：',
        feature1: '浏览您所在地区经过验证的专业人士',
        feature2: '查看评分、评论和专业领域',
        feature3: '比较价格和可用性',
        feature4: '为特定服务请求报价'
      },
      working: {
        title: '与提供商合作：',
        feature1: '通过平台直接沟通',
        feature2: '跟踪工作进度和完成情况',
        feature3: '管理付款和发票',
        feature4: '建立长期关系'
      },
      benefit: {
        label: '优势',
        content: '所有服务提供商都经过预验证，确保质量和可靠性。'
      }
    },
    expenses: {
      title: '财务跟踪 💰',
      description: '监控您的物业费用和财务表现。',
      categories: {
        title: '费用类别：',
        maintenance: '维护和维修',
        management: '物业管理',
        insurance: '保险和税收',
        utilities: '公用事业和服务'
      },
      insights: {
        title: '财务洞察：',
        feature1: '按物业跟踪总费用',
        feature2: '监控维护成本随时间的变化',
        feature3: '分析投资回报率和物业表现',
        feature4: '生成财务报告'
      },
      goal: {
        label: '目标',
        content: '保持详细记录以最大化税收减免并跟踪盈利能力。'
      }
    },
    communication: {
      title: '沟通和聊天 💬',
      description: '通过内置聊天系统与租户和服务提供商保持联系。',
      features: {
        title: '聊天功能：',
        feature1: '与租户直接消息',
        feature2: '服务提供商沟通',
        feature3: '文件和图片共享',
        feature4: '聊天历史和搜索'
      },
      bestPractices: {
        title: '沟通最佳实践：',
        feature1: '及时回应租户询问',
        feature2: '将所有沟通保持在平台内',
        feature3: '使用清晰、专业的语言',
        feature4: '记录重要对话'
      },
      advantage: {
        label: '优势',
        content: '集中式沟通使一切保持有序和可搜索。'
      }
    },
    completion: {
      title: '您已准备就绪！🎯',
              description: '恭喜！您现在知道如何导航和使用您的 EasyProperty 主页。',
      ready: {
        title: '准备开始！',
        description: '您现在拥有有效管理物业组合的所有知识。'
      },
      nextSteps: {
        title: '下一步：',
        step1: '添加您的第一个物业',
        step2: '创建租户账户',
        step3: '探索不同部分',
        step4: '设置您的偏好'
      },
      help: {
        text: '需要帮助？随时从帮助菜单访问此教程或联系我们的支持团队。'
      }
    }
  },

  // Navigation
  nav: {
    home: '首页',
    features: '功能',
    serviceProviders: '服务提供商',
    pricing: '定价',
    signIn: '登录',
    earlyAccess: '抢先体验'
  },

  // Authentication Pages
  auth: {
    login: {
      title: '欢迎回来！',
      subtitle: '登录您的账户',
      emailLabel: '邮箱地址',
      emailPlaceholder: '输入您的邮箱',
      passwordLabel: '密码',
      passwordPlaceholder: '输入您的密码',
      signInButton: '登录',
      processing: '处理中...',
      noAccount: '还没有账户？',
      createAccount: '创建新账户',
      copyright: '© 2025 EasyProperty. 版权所有。'
    }
  },

  // Brand
  brand: {
    name: 'EasyProperty',
    tagline: '简化物业管理'
  },
  
  // Hero Section
  hero: {
    badge: '抢先体验计划 - 名额有限',
    title: '物业管理',
    subtitle: '简单化',
    programSubtitle: '加入我们的独家抢先体验计划',
    description: '成为首批体验我们革命性物业管理平台的用户。连接经过验证的服务提供商，高效管理物业，并通过独家抢先体验福利发展您的投资组合。',
    earlyAccessBtn: '抢先体验',
    watchDemoBtn: '观看演示',
    trustIndicators: {
      noPayment: '无需付费',
      prioritySupport: '优先支持',
      limitedAvailability: '名额有限'
    }
  },

  // Statistics Section
  statistics: {
    propertyOwners: '物业所有者',
    serviceProviders: '服务提供商',
    propertiesManaged: '管理的物业',
    uptime: '正常运行时间'
  },
  
  // Scrolling Marquee
  marquee: {
    earlyAccess: '🚀 抢先体验计划 - 名额有限',
    noPayment: '发布期间无需付费',
    prioritySupport: '包含优先支持',
    exclusiveFeatures: '独家平台功能',
    firstBatch: '加入我们的首批用户',
    onboarding: '专业入职支持',
    verifiedNetwork: '经过验证的服务提供商网络',
    advancedTools: '先进的物业管理工具',
    analytics: '实时分析和报告',
    mobileApp: '移动应用访问',
    customerSuccess: '24/7客户成功团队'
  },
  
  // Early Access Banner
  earlyAccessBanner: {
    title: '🚀 抢先体验计划',
    description: '名额有限 • 无需付费 • 包含优先支持',
    joinNow: '立即加入'
  },
  
  // Features Section
  features: {
    title: '现代物业管理的强大功能',
    subtitle: '通过我们的独家抢先体验计划，率先体验这些功能。',
    features: [
      {
        title: '物业组合管理',
        description: '通过单一主页管理多个物业，提供全面的跟踪和分析。'
      },
      {
        title: '服务提供商网络',
        description: '连接经过验证的专业人士，提供维护、维修和物业服务。'
      },
      {
        title: '租户管理',
        description: '简化租户入职、沟通和收款流程。'
      },
      {
        title: '财务跟踪',
        description: '通过详细的财务报告和洞察监控收入、支出和投资回报率。'
      },
      {
        title: '文档管理',
        description: '在一个地方安全地存储和组织所有物业相关文档。'
      },
      {
        title: '移动访问',
        description: '通过我们的移动应用随时随地访问您的物业管理工具。'
      }
    ]
  },
  
  // Service Providers Section
  serviceProviders: {
    title: '探索服务提供商',
    subtitle: '抢先体验用户优先连接到我们经过验证的服务提供商网络。',
    joinPlatform: '抢先体验',
    learnMore: '了解更多',
    searchPlaceholder: '按名称、描述或位置搜索...',
    allSpecialties: '所有专业',
    sortByRating: '按评分排序',
    sortByName: '按名称排序',
    sortByLocation: '按位置排序',
    loading: '正在加载服务提供商...',
    noResults: '未找到服务提供商',
    noResultsDescription: '尝试调整搜索条件或稍后再检查。',
    servicesOffered: '提供的服务：',
    specialties: {
      plumbing: '管道',
      electrical: '电气',
      hvac: '暖通空调',
      carpentry: '木工',
      painting: '油漆',
      cleaning: '清洁',
      landscaping: '景观美化',
      roofing: '屋顶'
    }
  },
  
  // CTA Section
  cta: {
    title: '准备加入我们的独家抢先体验计划？',
    description: '抢先体验名额有限。立即加入，成为首批体验物业管理未来的用户。',
    button: '加入抢先体验'
  },
  
  // Footer (Chinese)
  footer: {
    description: '简化物业所有者和服务提供商的物业管理。',
    copyright: '版权所有。',
    platform: '平台',
    support: '支持',
    connect: '联系',
    signUp: '注册',
    signIn: '登录',
    serviceProviders: '服务提供商',
    features: '功能',
    pricing: '定价',
    helpCenter: '帮助中心',
    contactUs: '联系我们',
    privacyPolicy: '隐私政策',
    aboutUs: '关于我们',
    blog: '博客',
    careers: '职业'
  },
  
  // Registration Page
  registration: {
    title: '选择您的账户类型',
    subtitle: '选择最适合您需求的账户类型。物业所有者可以加入我们的独家抢先体验计划，而服务提供商加入我们的高级网络。',
    propertyOwner: {
      badge: '抢先体验',
      title: '物业所有者',
      description: '非常适合希望简化物业管理的房东、物业经理和房地产投资者。',
      benefits: [
        '加入我们的独家抢先体验计划',
        '免费访问所有平台功能',
        '连接经过验证的服务提供商',
        '优先支持和入职',
        '名额有限'
      ],
      button: '加入等候名单'
    },
    serviceProvider: {
      badge: '免费 + 高级',
      title: '服务提供商',
      description: '加入我们经过验证的专业人士网络，获得寻找您服务的物业所有者的访问权限。',
      benefits: [
        '免费注册和账户创建',
        '需要管理员批准',
        '升级到高级版：一次性费用99美元',
        '经过验证的专业徽章',
        '优先访问潜在客户和工作票'
      ],
      button: '免费加入提供商'
    },
    additionalInfo: {
      signIn: '已有账户？',
      signInLink: '在此登录',
      help: '需要帮助选择？',
      contact: '联系我们的支持团队',
      earlyAccessNotice: {
        title: '抢先体验计划',
        description: '我们目前正在接受有限数量的物业所有者加入我们的抢先体验计划。加入等候名单，在您的账户准备就绪时收到通知。抢先体验期间无需付费。'
      }
    },
    serviceProviderRegistration: {
      title: '加入服务提供商',
      subtitle: '创建您的专业账户，开始与物业所有者建立联系。',
      steps: {
        step1: '1',
        step2: '2',
        accountInfo: '账户信息',
        businessInfo: '商业信息'
      },
      form: {
        firstName: '名字',
        lastName: '姓氏',
        emailAddress: '邮箱地址',
        password: '密码',
        confirmPassword: '确认密码',
        phoneNumber: '电话号码',
        businessName: '商业名称',
        specialty: '专业',
        serviceArea: '服务区域',
        businessDescription: '商业描述',
        referralCode: '推荐码',
        invited: '受邀',
        optional: '可选'
      },
      placeholders: {
        selectSpecialty: '选择您的专业',
        serviceAreaPlaceholder: '例如：纽约，纽约州',
        businessDescriptionPlaceholder: '告诉物业所有者您的服务、经验以及您的独特之处...',
        referralCodePlaceholder: '如果您有推荐码，请输入',
        invitedPlaceholder: '您被物业所有者邀请'
      },
      specialties: {
        plumbing: '管道',
        electrical: '电气',
        hvac: '暖通空调',
        carpentry: '木工',
        painting: '油漆',
        cleaning: '清洁',
        landscaping: '景观美化',
        roofing: '屋顶',
        general: '通用'
      },
      buttons: {
        continueToBusiness: '继续填写商业详情',
        back: '返回',
        completeRegistration: '完成注册',
        creatingAccount: '正在创建账户...'
      },
      terms: {
        agreeTo: '我同意',
        termsOfService: '服务条款',
        and: '和',
        privacyPolicy: '隐私政策'
      },
      referral: {
        invitedBy: '您被邀请',
        invitedByReferrer: '被 {name} 邀请'
      },
      info: {
        freeRegistration: '免费注册流程',
        benefits: [
          '无需注册费',
          '管理员在24-48小时内批准',
          '批准后获得基本访问权限',
          '升级到高级版（99美元）获得验证徽章',
          '优先访问潜在客户和工作票',
          '无月费'
        ]
      },
      navigation: {
        home: '首页',
        signIn: '登录'
      },
      footer: {
        alreadyHaveAccount: '已有账户？',
        signInHere: '在此登录'
      }
    }
  },
  
  // Demo Modal
  demoModal: {
    title: '试用平台',
    subtitle: '无需注册即可体验您的仪表板',
    description: '使用示例数据浏览物业所有者仪表板：物业、租户、维护请求和费用。一目了然。',
    launchDemo: '启动交互式演示',
    orGetNotified: '或接收新功能通知',
    emailPlaceholder: '输入您的电子邮件',
    getNotified: '通知我',
    notifySuccess: '我们会在新功能上线时通知您。',
    close: '关闭',
    features: [
      '交互式主页之旅',
      '功能演示',
      '真实用例示例',
      '问答环节'
    ],
    launchInfo: '预计发布时间：2025年12月',
    emailLabel: '演示准备就绪时通知我：',
    captchaLabel: '安全检查：3 + 5 = ?',
    captchaPlaceholder: '输入答案'
  },
  
  // Features Page (Chinese)
  featuresPage: {
    hero: {
      title: '现代物业管理的强大功能',
      subtitle: '高效管理物业所需的一切，从租户管理到财务跟踪。',
      button: '抢先体验'
    },
    features: {
      propertyManagement: {
        category: '物业管理',
        dashboard: {
          title: '物业主页',
          description: '所有物业的集中视图，具有实时分析和洞察'
        },
        documents: {
          title: '文档管理',
          description: '存储和组织物业文档、合同和维护记录'
        },
        financial: {
          title: '财务跟踪',
          description: '监控每项物业投资的收入、支出和投资回报率'
        },
        maintenance: {
          title: '维护调度',
          description: '自动化维护提醒和服务调度'
        }
      },
      tenantManagement: {
        category: '租户管理',
        portal: {
          title: '租户门户',
          description: '租金支付、维护请求和沟通的自助服务门户'
        },
        rent: {
          title: '租金收取',
          description: '多种支付方式和滞纳金跟踪的自动化租金收取'
        },
        communication: {
          title: '沟通中心',
          description: '内置消息系统，实现无缝房东-租户沟通'
        },
        lease: {
          title: '租赁管理',
          description: '数字租赁协议、续约和合规跟踪'
        }
      },
      serviceProvider: {
        category: '服务提供商网络',
        verified: {
          title: '经过验证的专业人士',
          description: '为所有物业需求预先筛选和评级的服务提供商'
        },
        booking: {
          title: '即时预订',
          description: '具有实时可用性和定价的维护服务预订'
        },
        tracking: {
          title: '服务跟踪',
          description: '通过照片文档监控服务进度和完成情况'
        },
        cost: {
          title: '成本管理',
          description: '比较报价、跟踪支出和管理服务预算'
        }
      },
      analytics: {
        category: '分析与报告',
        performance: {
          title: '性能指标',
          description: '物业性能和租户满意度的综合分析'
        },
        market: {
          title: '市场洞察',
          description: '当地市场趋势和物业价值分析'
        },
        roi: {
          title: '投资回报率计算器',
          description: '计算和优化投资回报的高级工具'
        },
        reports: {
          title: '自定义报告',
          description: '为投资者、会计师和税务目的生成详细报告'
        }
      }
    },
    integrations: {
      title: '无缝集成',
      subtitle: '连接您喜爱的工具和服务，简化工作流程。',
      quickBooks: { name: 'QuickBooks' },
      stripe: { name: 'Stripe' },
      googleCalendar: { name: 'Google Calendar' },
      slack: { name: 'Slack' },
      zapier: { name: 'Zapier' },
      mailchimp: { name: 'Mailchimp' },
      dropbox: { name: 'Dropbox' },
      trello: { name: 'Trello' }
    },
    cta: {
      title: '准备体验物业管理的未来？',
      subtitle: '加入成千上万的物业所有者，他们信任EasyProperty高效管理他们的投资。',
      earlyAccess: '抢先体验',
      viewPricing: '查看定价'
    }
  },
  
  // Pricing Page
  pricingPage: {
    hero: {
      title: '简单、透明的定价',
      subtitle: '加入我们的独家抢先体验计划。在发布期间免费体验完整平台。',
      button: '抢先体验',
      viewFeatures: '查看功能'
    },
    pricing: {
      title: '选择您的计划',
      description: '抢先体验计划详情。发布期间无需付费。',
      monthly: '每月',
      yearly: '每年',
      save20: '节省20%',
      saveAmount: '每年节省${amount}！',
      perMonth: '/月',
      perYear: '/年',
      startFreeTrial: '开始免费试用',
      getStarted: '立即开始',
      mostPopular: '最受欢迎'
    },
    plans: {
      starter: {
        name: '入门版',
        description: '适合个人物业所有者',
        features: [
          '最多5套物业',
          '基本租户管理',
          '维护请求跟踪',
          '电子邮件支持',
          '移动应用访问',
          '基本报告'
        ]
      },
      professional: {
        name: '专业版',
        description: '适合不断增长的物业组合',
        features: [
          '最多25套物业',
          '高级租户门户',
          '自动化租金收取',
          '服务提供商网络',
          '优先支持',
          '高级分析',
          '文档管理',
          '多用户访问'
        ]
      },
      enterprise: {
        name: '企业版',
        description: '适合大型物业管理公司',
        features: [
          '无限物业',
          '自定义集成',
          '白标解决方案',
          '专属客户经理',
          '24/7电话支持',
          '自定义报告',
          'API访问',
          '高级安全功能'
        ]
      }
    },
    faq: {
      title: '常见问题',
      subtitle: '关于我们的定价和计划，您需要了解的一切。',
      questions: {
        changePlan: {
          question: '我可以随时更改我的计划吗？',
          answer: '是的！您可以随时升级或降级您的计划。更改立即生效，我们将根据账单调整进行折算。'
        },
        freeTrial: {
          question: '免费试用包括什么？',
          answer: '免费试用为您提供Starter计划30天的完整访问权限。无需信用卡，您可以随时取消。'
        },
        volumeDiscounts: {
          question: '您提供多套物业的折扣吗？',
          answer: '是的！我们为拥有大量物业的物业管理公司提供折扣。请联系我们的销售团队获取定制价格。'
        },
        setupFee: {
          question: '有设置费吗？',
          answer: '没有设置费！所有计划都包含免费入职和迁移协助，帮助您快速启动。'
        },
        paymentMethods: {
          question: '您接受哪些付款方式？',
          answer: '我们接受所有主要信用卡、PayPal和银行转账。所有付款都经过安全处理。'
        }
      }
    },
    comparison: {
      title: '计划对比',
      subtitle: '一目了然地查看每个计划包含的内容。',
      features: '功能',
      properties: '物业',
      tenantManagement: '租户管理',
      maintenanceTracking: '维护跟踪',
      serviceProviderNetwork: '服务提供商网络',
      rentCollection: '租金收取',
      documentManagement: '文档管理',
      analyticsReporting: '分析与报告',
      apiAccess: 'API访问',
      prioritySupport: '优先支持',
      whiteLabelSolutions: '白标解决方案'
    },
    cta: {
      title: '准备开始？',
      subtitle: '加入成千上万的物业所有者，他们信任EasyProperty高效管理他们的投资。',
      earlyAccess: '抢先体验',
      viewFeatures: '查看功能'
    }
  },

  // Service Providers Page (Chinese)
  serviceProvidersPage: {
    hero: {
      title: '值得信赖的服务提供商',
      subtitle: '触手可及',
      description: '连接经过验证的专业人士，满足您所有的物业维护和管理需求。优质服务、竞争性定价和安心保障。',
      joinAsOwner: '加入物业所有者',
      becomeProvider: '成为服务提供商'
    },
    stats: {
      // Stats section translations
    },
    search: {
      placeholder: '搜索提供商、服务或位置...',
      allSpecialties: '所有专业',
      sortByRating: '按评分排序',
      sortByName: '按名称排序',
      sortByLocation: '按位置排序'
    },
    specialty: {
      all: '所有专业'
    },
    sort: {
      rating: '评分',
      name: '名称',
      location: '位置'
    },
    loading: '正在加载服务提供商...',
    noResults: '未找到服务提供商',
    noResultsDescription: '尝试调整搜索条件或浏览所有专业。',
    noProvidersFound: {
      title: '未找到服务提供商',
      description: '尝试调整搜索条件或稍后再检查。',
      joinAsProvider: '成为服务提供商'
    },
    provider: {
      servicesOffered: '提供的服务:',
      contactProvider: '联系提供商',
      viewProfile: '查看资料'
    },
    cta: {
      title: '准备与顶级服务提供商联系？',
      description: '加入成千上万的物业所有者，他们信任EasyProperty与经过验证的专业人士联系。',
      getStarted: '免费开始',
      learnMore: '了解更多'
    },
    servicesOffered: '提供的服务',
    specialties: {
      plumbing: '管道',
      electrical: '电气',
      hvac: '暖通空调',
      carpentry: '木工',
      painting: '油漆',
      cleaning: '清洁',
      landscaping: '景观美化',
      roofing: '屋顶',
      general: '通用'
    }
  },

  // Sidebar Navigation
  sidebar: {
            dashboard: '主页',
    properties: '物业',
    tenants: '租户',
    tickets: '工单',
    expenses: '费用',
    earnings: '收入',
    serviceProviders: '服务提供商',
    chats: '聊天',
    helpTutorial: '帮助 & 教程',
    logout: '登出',
    showTutorial: '显示教程',
    notifications: '通知',
    markAllRead: '全部标记为已读',
    noNotifications: '无通知'
  },

  // Feedback System
  feedback: {
    title: '提交反馈',
    helpMessage: '您的反馈有助于我们改进EasyProperty，为所有用户提供更好的服务。我们感谢您的意见！',
    feedbackType: '反馈类型',
    priority: '优先级',
    content: '反馈内容',
    contentPlaceholder: '请详细描述您的反馈。如果可能，请包含具体示例...',
    deviceType: '设备类型',
    browserInfo: '浏览器信息',
    submit: '提交反馈',
    submitting: '提交中...',
    pleaseEnterContent: '请输入您的反馈内容。',
    thankYouMessage: '感谢您的反馈！我们感谢您为改进EasyProperty提供的意见。',
    submissionError: '提交反馈失败。请重试。',
    unknownUser: '未知用户',
    types: {
      general: '一般评论',
      bug: '错误报告',
      feature: '功能请求',
      uiux: '界面/用户体验反馈',
      performance: '性能问题'
    },
    priorities: {
      low: '低',
      medium: '中',
      high: '高',
      critical: '紧急'
    },
    devices: {
      desktop: '桌面',
      mobile: '移动设备',
      tablet: '平板'
    }
  },

  // Common UI Elements
  common: {
    cancel: '取消'
  },

  // Dashboard Translations
  dashboard: {
    // Common Dashboard Elements
    common: {
      loading: '加载中...',
      refresh: '刷新',
      viewAll: '查看全部',
      addNew: '添加新',
      edit: '编辑',
      delete: '删除',
      save: '保存',
      cancel: '取消',
      close: '关闭',
      search: '搜索',
      filter: '筛选',
      sort: '排序',
      actions: '操作',
      status: '状态',
      createdAt: '创建于',
      updatedAt: '更新于',
      noData: '暂无数据',
      emptyState: '开始添加您的第一个项目',
      help: '帮助',
      tutorial: '教程',
      skip: '跳过',
      next: '下一步',
      previous: '上一步',
      finish: '完成',
      complete: '完成'
    },

    // Property Owner Dashboard
    owner: {
      title: '物业所有者主页',
      welcome: '欢迎回来',
      stats: {
        properties: '总物业',
        tenants: '总租户',
        tickets: '活动请求',
        expenses: '总支出',
        revenue: '总收入',
        occupancy: '入住率'
      },
      sections: {
        properties: {
          title: '您的物业',
          subtitle: '管理您的物业组合',
          addProperty: '添加物业',
          noProperties: '暂无物业',
          emptyState: '开始通过添加您的第一个物业来构建您的组合。',
          addFirstProperty: '添加您的第一个物业',
          needHelp: '需要帮助？',
          propertyName: '物业名称',
          address: '地址',
          type: '物业类型',
          status: '状态',
          vacant: '空置',
          occupied: '已占用'
        },
        tenants: {
          title: '您的租户',
          subtitle: '管理租户关系',
          createTenant: '创建租户',
          noTenants: '暂无租户',
          emptyState: '将租户分配给您要管理的物业。',
          createFirstTenant: '创建第一个租户',
          needHelp: '需要帮助？',
          tenantName: '租户名称',
          email: '电子邮件',
          phone: '电话',
          rent: '租金',
          leaseStart: '租赁开始',
          leaseEnd: '租赁结束'
        },
        maintenance: {
          title: '最近请求',
          subtitle: '跟踪维护和维修请求',
          noRequests: '暂无维护请求',
          emptyState: '当租户提交维护工单时，请求将显示在这里。',
          learnHow: '了解如何使用',
          requestTitle: '请求标题',
          property: '物业',
          priority: '优先级',
          assignedTo: '指派给',
          estimatedCost: '预估费用'
        },
        financial: {
          title: '财务概览',
          subtitle: '跟踪您的物业投资',
          income: '收入',
          expenses: '支出',
          profit: '利润',
          roi: '投资回报率',
          monthly: '每月',
          yearly: '每年'
        }
      },
      modals: {
        addProperty: {
          title: '添加新物业',
          description: '将新物业添加到您的组合中'
        },
        createTenant: {
          title: '创建新租户',
          description: '创建租户账户并分配给物业'
        },
        createTenantAccount: {
          title: '创建租户账户',
          description: '创建新的租户账户并将其分配给物业',
          form: {
            tenantName: '租户姓名',
            tenantNamePlaceholder: '输入租户全名',
            emailAddress: '邮箱地址',
            emailPlaceholder: '输入邮箱地址',
            phoneNumber: '电话号码',
            phonePlaceholder: '输入电话号码',
            property: '物业',
            propertyPlaceholder: '选择物业',
            leaseStartDate: '租约开始日期',
            leaseEndDate: '租约结束日期',
            monthlyRent: '月租金',
            rentPlaceholder: '输入月租金',
            defaultPassword: '默认密码',
            passwordPlaceholder: '输入默认密码',
            confirmPassword: '确认密码',
            confirmPlaceholder: '确认默认密码',
            passwordHint: '最少6个字符'
          },
          info: {
            title: '重要信息',
            description: '创建账户后，您将收到登录凭据以与租户分享。租户将在首次登录时被提示更改密码。'
          },
          buttons: {
            cancel: '取消',
            createAccount: '创建租户账户',
            creating: '创建账户中...'
          },
          success: {
            title: '租户账户创建成功！',
            credentials: '登录凭据',
            shareInstructions: '请与租户分享这些凭据。他们将在首次登录时被提示更改密码。',
            copyCredentials: '复制凭据',
            credentialsCopied: '凭据已复制到剪贴板！',
            close: '关闭'
          },
          errors: {
            tenantNameRequired: '租户姓名是必需的',
            emailRequired: '邮箱是必需的',
            phoneRequired: '电话号码是必需的',
            propertyRequired: '物业选择是必需的',
            leaseStartRequired: '租约开始日期是必需的',
            leaseEndRequired: '租约结束日期是必需的',
            rentRequired: '月租金是必需的',
            passwordRequired: '默认密码是必需的',
            passwordsMismatch: '密码不匹配',
            passwordTooShort: '密码必须至少6个字符',
            noVacantProperties: '没有可用的空置物业',
            selectedPropertyNotFound: '未找到选定的物业'
          }
        },
        passwordChange: {
          title: '需要更改密码',
          description: '出于安全原因，您必须先更改默认密码才能继续。',
          currentPassword: '当前密码',
          newPassword: '新密码',
          confirmPassword: '确认新密码',
          passwordHint: '密码必须至少6个字符'
        },
        profileCompletion: {
          title: '完善您的资料',
          description: '请通过提供您的联系方式来完善您的资料。这有助于我们提供更好的服务。',
          phoneNumber: '电话号码',
          address: '地址',
          phoneRequired: '物业所有者账户必需',
          addressRequired: '物业所有者账户必需'
        }
      },
      pages: {
        properties: {
          title: '物业管理',
          subtitle: '管理您的物业组合',
          addProperty: '添加物业',
          editProperty: '编辑物业',
          totalProperties: '总物业',
          inPortfolio: '在您的组合中',
          yourProperties: '您的物业',
          managePortfolio: '管理您的房地产组合',
          propertyName: '物业名称',
          address: '地址',
          type: '物业类型',
          status: '状态',
          monthlyRent: '月租金',
          bedrooms: '卧室',
          bathrooms: '浴室',
          squareFootage: '建筑面积',
          residential: '住宅',
          commercial: '商业',
          industrial: '工业',
          vacant: '空置',
          occupied: '已出租',
          maintenance: '维护',
          actions: '操作',
          edit: '编辑',
          delete: '删除',
          assignTenant: '分配租户',
          viewDetails: '查看详情',
          confirmDelete: '您确定要删除此物业吗？',
          deleteSuccess: '物业删除成功',
          addSuccess: '物业添加成功',
          updateSuccess: '物业更新成功',
          property: '物业',
          properties: '物业'
        },
        tenants: {
          title: '租户管理',
          subtitle: '管理您的租户关系',
          createTenant: '创建租户',
          totalTenants: '总租户',
          managedByYou: '由您管理',
          yourTenants: '您的租户',
          manageRelationships: '管理租户关系',
          tenantName: '租户姓名',
          email: '邮箱',
          phone: '电话',
          property: '物业',
          leaseStart: '租约开始',
          leaseEnd: '租约结束',
          rentAmount: '租金金额',
          status: '状态',
          active: '活跃',
          inactive: '非活跃',
          pending: '待定',
          actions: '操作',
          edit: '编辑',
          delete: '删除',
          sendMessage: '发送消息',
          viewLease: '查看租约',
          confirmDelete: '您确定要移除此租户吗？',
          deleteSuccess: '租户移除成功',
          createSuccess: '租户创建成功',
          tenant: '租户',
          tenants: '租户'
        },
        tickets: {
          title: '维护工单',
          subtitle: '跟踪和管理维护请求',
          newTicket: '新工单',
          totalTickets: '总工单',
          activeRequests: '活跃请求',
          yourTickets: '您的工单',
          trackRequests: '跟踪维护和维修请求',
          ticketId: '工单ID',
          columnTitle: '标题',
          property: '物业',
          tenant: '租户',
          priority: '优先级',
          status: '状态',
          assignedTo: '分配给',
          createdAt: '创建时间',
          updatedAt: '更新时间',
          open: '开放',
          inProgress: '进行中',
          completed: '已完成',
          closed: '已关闭',
          high: '高',
          medium: '中',
          low: '低',
          urgent: '紧急',
          actions: '操作',
          view: '查看',
          assign: '分配',
          close: '关闭',
          reopen: '重新开放',
          ticket: '工单',
          tickets: '工单'
        },
        expenses: {
          title: '费用管理',
          subtitle: '跟踪和管理物业费用',
          addExpense: '添加费用',
          totalExpenses: '总费用',
          thisMonth: '本月',
          yourExpenses: '您的费用',
          trackExpenses: '跟踪和管理物业费用',
          description: '描述',
          amount: '金额',
          category: '类别',
          property: '物业',
          date: '日期',
          receipt: '收据',
          actions: '操作',
          edit: '编辑',
          delete: '删除',
          viewReceipt: '查看收据',
          confirmDelete: '您确定要删除此费用吗？',
          deleteSuccess: '费用删除成功',
          addSuccess: '费用添加成功',
          updateSuccess: '费用更新成功'
        },
        chats: {
          title: '消息与沟通',
          subtitle: '与租户和服务提供商沟通',
          newMessage: '新消息',
          totalChats: '总对话',
          activeChats: '活跃聊天',
          yourChats: '您的对话',
          communicateWith: '与租户和服务提供商沟通',
          searchChats: '搜索对话...',
          noChats: '暂无对话',
          startChatting: '开始您的第一次对话',
          sendMessage: '发送消息...',
          online: '在线',
          offline: '离线',
          typing: '正在输入...',
          lastSeen: '最后在线'
        }
      },
      onboarding: {
        welcome: '欢迎使用EasyProperty！🎉',
        subtitle: '您已设置好，准备开始管理您的物业。让我们快速浏览一下，帮助您入门。',
        startTutorial: '开始教程',
        skipForNow: '现在跳过',
        tutorial: {
          title: '物业所有者教程',
          welcome: '欢迎使用EasyProperty！🎉',
          dashboardOverview: '主页概览 📊',
          navigation: '导航 & 侧边栏 🧭',
          properties: '管理物业 🏠',
          tenants: '租户管理 👥',
          maintenance: '维护请求 🔧',
          serviceProviders: '服务提供商网络 🛠️',
          expenses: '财务跟踪 💰',
          communication: '沟通 & 聊天 💬',
          completion: '您已准备就绪！🎯'
        }
      }
    },

    // Service Provider Dashboard
    serviceProvider: {
      title: '服务提供商主页',
      welcome: '欢迎回来',
      stats: {
        jobs: '总工单',
        completed: '已完成',
        pending: '待处理',
        earnings: '总收入',
        rating: '平均评分',
        reviews: '总评价'
      },
      sections: {
        jobs: {
          title: '活跃工单',
          subtitle: '管理您当前的服务请求',
          noJobs: '暂无活跃工单',
          emptyState: '当物业所有者向您分配工作时，工单将显示在这里。',
          jobTitle: '工单标题',
          property: '物业',
          owner: '物业所有者',
          priority: '优先级',
          estimatedTime: '预估时间',
          status: '状态'
        },
        requests: {
          title: '服务请求',
          subtitle: '来自物业所有者的最新请求',
          noRequests: '暂无新服务请求',
          emptyState: '当物业所有者提交新请求时，它们将显示在这里。',
          viewDetails: '查看详情',
          accept: '接受',
          decline: '拒绝',
          quote: '发送报价'
        },
        schedule: {
          title: '日程安排',
          subtitle: '管理您的可用性和预约',
          today: '今天',
          thisWeek: '本周',
          thisMonth: '本月',
          available: '可用',
          busy: '忙碌',
          unavailable: '不可用'
        },
        earnings: {
          title: '收入与分析',
          subtitle: '跟踪您的收入和表现',
          totalEarnings: '总收入',
          thisMonth: '本月',
          thisYear: '今年',
          averagePerJob: '每单平均',
          topServices: '热门服务'
        }
      },
      modals: {
        jobDetails: {
          title: '工单详情',
          description: '查看和管理工单信息'
        },
        sendQuote: {
          title: '发送报价',
          description: '为请求的服务提供报价'
        },
        updateStatus: {
          title: '更新工单状态',
          description: '更新当前工单的进度'
        }
      }
    },

    // Tenant Dashboard
    tenant: {
      title: '租户主页',
      welcome: '欢迎回来',
      stats: {
        rent: '月租金',
        dueDate: '到期日',
        balance: '余额',
        maintenance: '待处理请求',
        documents: '文档',
        messages: '消息'
      },
      sections: {
        rent: {
          title: '租金与支付',
          subtitle: '管理您的租金支付并查看历史记录',
          currentRent: '当前租金',
          nextPayment: '下次支付',
          paymentHistory: '支付历史',
          makePayment: '支付租金',
          paymentMethods: '支付方式',
          noPayments: '暂无支付历史'
        },
        maintenance: {
          title: '维护请求',
          subtitle: '提交和跟踪维护请求',
          newRequest: '新请求',
          noRequests: '暂无维护请求',
          emptyState: '当您需要维护或维修时，请提交请求。',
          submitRequest: '提交请求',
          requestTitle: '请求标题',
          description: '描述',
          priority: '优先级',
          category: '类别',
          status: '状态'
        },
        documents: {
          title: '文档',
          subtitle: '访问您的租赁协议和重要文件',
          lease: '租赁协议',
          rules: '房屋规则',
          policies: '政策',
          noDocuments: '暂无文档',
          download: '下载',
          view: '查看'
        },
        communication: {
          title: '沟通',
          subtitle: '向您的物业所有者和服务提供商发送消息',
          newMessage: '新消息',
          noMessages: '暂无消息',
          emptyState: '开始与您的物业所有者对话。',
          sendMessage: '发送消息',
          to: '收件人',
          subject: '主题',
          message: '消息'
        }
      },
      modals: {
        newRequest: {
          title: '新维护请求',
          description: '提交新的维护或维修请求'
        },
        newMessage: {
          title: '新消息',
          description: '向您的物业所有者发送消息'
        },
        payment: {
          title: '支付租金',
          description: '支付租金或支付其他费用'
        }
      }
    }
  }
};

// Export all translations
export const translations = { en, zh };
